import * as httpService from "../../services/httpService";
import * as localStorageKeys from "../../constants/localStorageKeys";

import React, { useRef } from 'react'
import {
  clearSavedNewScreeningRequest,
  clearSavedSentScreeningRequest,
} from "../../utils";

import IdleTimer from 'react-idle-timer'
import { useHistory } from 'react-router-dom';

const IdleTimerContainer: React.FC = () =>  {
  const idleTimerRef = useRef(null)
  const history = useHistory();
  const timeout = 30*60*1000;

  
  const onIdle = () => {
    console.log("User logged out");
    httpService.logout();
    localStorage.removeItem(localStorageKeys.USER);
    clearSavedNewScreeningRequest();
    clearSavedSentScreeningRequest();
    history.push("/login");
  }
  return (
    <div>
      <IdleTimer ref={idleTimerRef as any} timeout={timeout} onIdle={onIdle}></IdleTimer>
    </div>
  )
}

export default IdleTimerContainer